import React, { Component } from 'react';
import '../custom.css'

export class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render(){//The CSS for the class "versionNumber" is still left-aligned, see about making it right in the future if you're really bored
        return (
            <div>
                <div className="versionNumber">
                    Version 3.10.1
                </div>
            </div>
        );
    }
}